<template>
    <div class="pageBox">
        <div class="cateRow"
             v-show="category!=null||category.length>1||category_solution!=null||category_solution.length>1">
            <div class="cateBox">
                <div class="cateRow_item"
                     v-show="category!=null||category.length>1">
                    <div class="rowTitle">服务目录：</div>
                    <div class="categoryBox">
                        <el-checkbox-group v-model="checkedCate" @change="handleCheckedCate1Change">
                            <el-checkbox
                                v-for="(item,index) in category"
                                :label="item.id"
                                :key="index">
                                {{ item.serivceTypeName }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
                <div class="cateRow_item"
                     v-show="category_solution!=null||category_solution.length>1">
                    <div class="rowTitle">解决方案：</div>
                    <div class="categoryBox">
                        <el-checkbox-group v-model="checkedCate_solution" @change="handleCheckedCate2Change">
                            <el-checkbox
                                v-for="(item,index) in category_solution"
                                :label="item.id"
                                :key="index">
                                {{ item.serivceTypeName }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>

                <div class="selectingRow">
                    <span class="selecting">您已选择：</span>
                    <div class="item" v-if="checkedCate.length>0||checkedCate_solution.length>0">
                        {{ checkedName }}
                        <span class="right" @click="resetCategory">√</span>
                    </div>
                    <div class="item reset" @click="resetCategory"
                         v-if="checkedCate.length>0||checkedCate_solution.length>0">
                        重置
                    </div>
                </div>
            </div>
        </div>
        <div class="ListBox">
            <div class="ListBoxRow" v-if="product.length>0">
                <div class="ListFrame">
                    <div v-for="(item,index) in product"
                         class="aBox"
                         :key="index">
                        <router-link :to="{name:'ProductDetail',params:{pId:item.id}}"
                                     class="item">
                            <div class="imgBox">
                                <img :src="item.productImg" :alt="item.productName">
                            </div>
                            <div class="name">{{ item.productName }}</div>
                            <div class="info">{{ item.serviceInfo }}</div>
                            <div class="addCart">
                                <span>加入购物车</span>
                                <img src="../assets/images/cart_white.png" alt="购物车">
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="pagination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageIndex"
                        :page-sizes="[8, 12, 16, 20]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount">
                    </el-pagination>
                </div>
            </div>
            <div class="nodata" v-else>本目录下暂无产品！请重置</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "productList",
    data() {
        return {
            //服务类别目录
            category: [],
            //解决方案目录
            category_solution: [],
            pageIndex: 1,
            pageSize: 8,
            totalCount: 0,
            //服务产品
            product: [],
            //解决方案产品
            product_solution: [],
            // 选择的服务目录
            checkedCate: [],
            //选择的解决方案目录
            checkedCate_solution: [],
            // 选择的目录名称
            checkedName: '全部服务'
        }
    },
    watch: {
        'checkedName'() {
            document.title = this.checkedName + this.$suffix
        }
    },
    mounted() {
        this.$store.commit('setNav', 3)
        document.title = this.checkedName + this.$suffix
        this.getFirstServeType()
        this.getFirstSolutionType()
        this.getProductList(0)
    },
    methods: {
        handleSizeChange(val) {
            this.pageSize = val
            this.resetList()
        },
        handleCurrentChange(val) {
            this.pageIndex = val
            this.resetList()
        },

        /**
         * 服务复选框选择事件
         **/
        handleCheckedCate1Change(value) {
            this.checkedCate_solution = []
            if (value.length > 1) {
                this.checkedCate = []
                this.checkedCate.push(value[1])
            }
            // console.log(this.checkedCate)
            // console.log('全部目录', this.category)
            if (this.checkedCate.length > 0) {
                this.category.forEach((item) => {
                    if (item.id == this.checkedCate[0]) {
                        this.checkedName = item.serivceTypeName;
                    }
                })
            } else {
                this.checkedName = '全部目录'
            }
            this.getProductList(this.checkedCate[0])
        },

        /**
         * 解决方案复选框选择事件
         **/
        handleCheckedCate2Change(value) {
            this.checkedCate = []
            if (value.length > 1) {
                this.checkedCate_solution = []
                this.checkedCate_solution.push(value[1])
            }
            // console.log(this.checkedCate_solution)
            // console.log('全部目录', this.category_solution)
            if (this.checkedCate_solution.length > 0) {
                this.category_solution.forEach((item) => {
                    if (item.id == this.checkedCate_solution[0]) {
                        this.checkedName = item.serivceTypeName;
                    }
                })
            } else {
                this.checkedName = '全部目录'
            }
            this.getProductList(this.checkedCate_solution[0])
        },

        /**
         * 重置目录
         */
        resetCategory() {
            this.checkedCate = []
            this.checkedCate_solution = []
            this.checkedName = '全部目录'
            this.getProductList(0)
        },

        /**
         *  获取一级服务类别
         */
        getFirstServeType() {
            this.$post('/V1/ServiceType/GetFirstServiceType', {})
                .then((res) => {
                    // console.log('cate', res)
                    if (res.success) {
                        this.category = res.response
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
        },

        /**
         *  获取一级解决方案类别
         */
        getFirstSolutionType() {
            this.$post('/V1/SolutionType/GetFirstServiceType', {})
                .then((res) => {
                    // console.log('cate', res)
                    if (res.success) {
                        this.category_solution = res.response
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
        },

        /**
         * 获取产品列表
         * @param id 产品类别id
         */
        getProductList(id) {
            this.$post('/V1/Product/GetPrtoductsList', {
                "pageSize": this.pageSize,
                "pageIndex": this.pageIndex,
                "typeId": id
            })
                .then((res) => {
                    // console.log('list', res)
                    if (res.success) {
                        this.product = res.response.data
                        this.totalCount = res.response.totalCount
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
        },

        /**
         * 修改分页参数后，重新获取产品列表
         */
        resetList() {
            let tmp;
            if (this.checkedCate.length > 0) {
                tmp = this.checkedCate[0]
            } else {
                tmp = this.checkedCate_solution[0]
            }
            this.getProductList(tmp)
        },
    }
}
</script>

<style scoped lang="less">
::v-deep .el-checkbox-group label {
    margin-bottom: 10px;
    font-size: 16px !important;
}

::v-deep .el-checkbox__label {
    font-size: 16px !important;
}

.pageBox {
    display: flex;
    flex-direction: column;

    .cateRow {
        background-color: white;
        border-top: 1px solid #f9f9f9;

        .cateBox {
            width: 1210px;
            margin: 0 auto;
            display: flex;
            flex-direction: column;

            .cateRow_item {
                display: flex;
                flex-direction: row;
                border-bottom: 1px dashed #eeeeee;
                padding: 20px 0px;


                .rowTitle {
                    width: 100px;
                    min-width: 100px;
                    font-size: 16px;
                    font-weight: bold;
                }

                .categoryBox {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    font-size: 15px;
                }
            }

            .selectingRow {
                padding: 20px 0px;
                display: flex;
                flex-direction: row;
                min-height: 46px;

                .selecting {
                    line-height: 35px;
                    width: 100px;
                    min-width: 100px;
                }

                .item {
                    text-align: center;
                    padding: 10px 20px;
                    line-height: 20px;
                    margin: 0px 10px 10px 0px;
                    background-color: #1f2d5c;
                    color: white;
                    border-radius: 3px;
                    cursor: pointer;
                    position: relative;

                    .right {
                        position: absolute;
                        right: 1px;
                        top: 1px;
                        background-color: white;
                        color: #1f2d5c;
                        font-size: 12px;
                        font-weight: bold;
                        line-height: 12px;
                        width: 12px;
                        height: 12px;
                        border-radius: 2px;
                    }
                }

                .reset {
                    background-color: #e5e5e5;
                    color: #1f2d5c;
                    font-weight: bold;
                    border-radius: 5px;
                    cursor: pointer;
                    margin-left: 20px;
                }
            }
        }
    }

    .ListBox {
        background-color: #f9f9f9;
        min-height: 400px;

        .ListBoxRow {
            display: flex;
            flex-direction: column;
            padding: 20px 0px;

            .ListFrame {
                width: 1210px;
                margin: 0 auto 20px;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;

                .aBox {
                    margin-top: 15px;
                    margin-bottom: 10px;
                    margin-right: 18px;

                    .item {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        padding: 20px;
                        width: 249px;
                        height: 249px;
                        background-color: white;
                        border-radius: 5px;

                        .imgBox {
                            width: 250px;
                            height: 125px;
                            overflow: hidden;
                            border: 1px solid #cccccc;
                            margin-bottom: 10px;

                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }

                        .name {
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            color: #1f2d5c;
                            font-size: 18px;
                            max-width: 100%;
                            margin-bottom: 20px;
                            height: 24px;
                        }

                        .info {
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            color: #999;
                            font-size: 15px;
                            max-width: 100%;
                            margin-bottom: 10px;
                            height: 20px;
                        }

                        .addCart {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            color: #f1f1f1;
                            font-size: 15px;
                            background-color: #1f2d5c;
                            padding: 10px 14px;
                            border-radius: 10px;
                            cursor: pointer;
                            opacity: 0;
                            transition: .2s;

                            img {
                                margin-left: 5px;
                            }
                        }
                    }
                }

                .aBox:hover {
                    box-shadow: 0px 0px 10px 0px #d4d4d4;
                    margin-top: 1px;
                    margin-bottom: 24px;
                    transition: .4s;

                    .addCart {
                        transition: .5s;
                        opacity: 1 !important;
                    }
                }

                .aBox:nth-child(4n) {
                    margin-right: 0;
                }
            }

            .pagination {
                width: 1210px;
                margin: 0 auto;
            }
        }

        .nodata {
            width: 1210px;
            margin: 0 auto;
            line-height: 400px;
            color: red;
            width: fit-content;
        }
    }
}

</style>
